import React from 'react'
import CountUp from 'react-countup'

export default function WhyIndiaCounter() {
  return (
    <>
        <section className="py-3 bg-primary">
            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-6">
                        <div className="counter-box py-4 text-center">
                            <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={3.7}/>T+</h2>
                            <h4 className="counter-head text-light title-dark">GDP</h4>
                            <h6 className="counter-head text-light title-dark">Third-largest economy by 2030</h6>
                        </div>
                    </div>

                    <div className="col-md-3 col-6">
                        <div className="counter-box py-4 text-center">
                            <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={850}/>M+</h2>
                            <h4 className="counter-head text-light title-dark">Internet Users</h4>
                            <h6 className="counter-head text-light title-dark">Second-largest online population</h6>
                        </div>
                    </div>

                    <div className="col-md-3 col-6">
                        <div className="counter-box py-4 text-center">
                            <h2 className="mb-0 text-white title-dark mt-2"><CountUp end={1.5}/>M+</h2>
                            <h4 className="counter-head text-light title-dark">Engineers/Year</h4>
                            <h6 className="counter-head text-light title-dark">Tech and innovation powerhouse</h6>
                        </div>
                    </div>

                    <div className="col-md-3 col-6">
                        <div className="counter-box py-4 text-center">
                            <h2 className="mb-0 text-white title-dark mt-2">#3</h2>
                            <h4 className="counter-head text-light title-dark">Renewable Energy</h4>
                            <h6 className="counter-head text-light title-dark">Clean energy leader</h6>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
    </>
  )
}
